export default __webpack_public_path__ + "images/interior1_2028577f1397e4c9d0c3bf4441a60ca7.jpg";